import { Component } from 'react';
import PropTypes from "prop-types";
import { Link, Route, Routes } from "react-router-dom";

// Helpers.
import Helmet from "react-helmet";

// Constants.
import { DATA_INITIALISING, DATA_LOADED, DATA_LOADING } from "../../../../component/Constants";

// APis
import IntegrationsApi from "../../../../api/Integrations";

//Types
import NewRelicType from "../../../../types/integration/IntegrationType";

// Components.
import Breadcrumb from "../../../../container/breadcrumb";
import HeaderActions from "../../../../container/header_actions";
import ConditionalRender from "../../../../helpers/ConditionalRender";
import Detail from './Detail';
import List from "./List";


interface NewRelicProps {
    toggleMenu: Function,
    isAdmin: boolean
}

interface NewRelicState {
    loading: number,
    newRelic: NewRelicType[],
}

const initialState = {
    loading: DATA_INITIALISING,
    newRelic: []
}

class NewRelic extends Component<NewRelicProps, NewRelicState> {
    static propTypes: {
        toggleMenu: PropTypes.Validator<(...args: any[]) => any>,
        isAdmin: PropTypes.Validator<boolean>;
    };

    constructor(props: NewRelicProps) {
        super(props);

        this.state = initialState;
    };

    async getData() {
        const newRelic = await IntegrationsApi.getIntegrationData('newrelic');
        this.setState({
            loading: DATA_LOADED,
            newRelic
        });
    }

    componentDidMount() {
        const { loading } = this.state;

        if (loading === DATA_INITIALISING) {

            this.setState({
                loading: DATA_LOADING
            });

            this.getData();
        }
    }

    /* Action Methods */
    refresh = () => {

        this.setState({
            loading: DATA_LOADING
        });

        this.getData();
    }

    render() {
        const { loading, newRelic } = this.state;

        return (
            <div id="content">
                <Helmet>
                    <title>New Relic - Settings - DBmarlin</title>
                    <meta name="description" content="Manage New Relic"/>
                </Helmet>

                <div id="top-header-wrapper" className="row row-cols-2">
                    <Breadcrumb heading="New Relic">
                        <Link to="/admin">Settings</Link>
                        <Link to="/admin/integrations">Integrations</Link>
                        <span>New Relic</span>
                    </Breadcrumb>
                    <HeaderActions toggleMenu={this.props.toggleMenu} refresh={this.refresh}
                                  />
                </div>

                <div className="loader">
                    <ConditionalRender if={false}>
                        <div className="bar"/>
                    </ConditionalRender>
                </div>

                <div className="row row-cols-1">
                    <Routes>
                        <Route path="/:actionId" element={<Detail refresh={this.refresh} newRelic={newRelic} isAdmin={this.props.isAdmin}/>}/>
                        <Route path="/" element={<List loading={loading} newRelic={newRelic} refresh={this.refresh} isAdmin={this.props.isAdmin}/>}/>
                    </Routes>
                </div>
            </div>
        )
    }
}

NewRelic.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired
};

export default NewRelic;
